<template>
  <div id="app">
    <AppComponent />
  </div>
</template>

<script>
import AppComponent from "./components/AppComponent.vue";

export default {
  name: "App",
  components: {
    AppComponent
  },
  data: function () {
    return {
      
    };
  },
  mounted: function () {

  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #818384;
  height:100%;
}

::-moz-selection {
  color: rgb(255, 174, 0);
}
::selection {
  color: rgb(255, 166, 0);
  background-color: grey;
}

body::-webkit-scrollbar {
  width: 1rem;
}
body::-webkit-scrollbar-track {
  background: #212121;   
}
body::-webkit-scrollbar-thumb {
  background-color: grey;   
  border-radius: 20px;     
  border: 3px solid #212121;
}
</style>
